import React, { useMemo } from 'react';
import { Dimmer, Loader, Button, Grid } from 'semantic-ui-react';
import RenderSection from '../renderSections';
import { FormData } from '../../types';
import { useNotificationEmails } from '../../hooks/useNotificationEmails';
interface PolicyStepProps {
  estateId?: string;
}

const PolicyStep: React.FC<PolicyStepProps> = ({ estateId }) => {
  const defaultFormData: FormData = useMemo(
    () => ({
      creationResponsible: false,
      client: false,
      estateMain: false,
      estateManager: false,
      tempMail: '',
      additionalRecipient: []
    }),
    []
  );

  const subcategories = useMemo(
    () => [
      'policyConfirmation',
      'cancellationRequest',
      'expirationNotice',
      'renewalRequest'
    ],
    []
  );

  const titleMap: Record<string, string> = {
    policyConfirmation: 'Confirmação da Apólice/Anexo PDF',
    cancellationRequest: 'Solicitação de cancelamento',
    expirationNotice: 'Aviso de Vencimento/Expiração',
    renewalRequest: 'Solicitação de renovação'
  };

  const { loading, formData, handleUpdateFormData, handleSave } = useNotificationEmails({
    estateId,
    category: 'policy',
    subcategories,
    defaultFormData
  });

  return (
    <>
      <Dimmer active={loading} page>
        <Loader inline />
      </Dimmer>

      {subcategories.map(subcategory => (
        <RenderSection
          key={subcategory}
          title={titleMap[subcategory]}
          sectionKey={subcategory}
          formData={formData[subcategory]}
          onUpdate={handleUpdateFormData}
        />
      ))}

      <Grid style={{ marginLeft: '65%' }}>
        <Grid.Row columns={2} style={{ gap: '1rem' }}>
          <Button basic size="large">
            Cancelar
          </Button>
          <Button color="green" size="large" onClick={handleSave}>
            Salvar alterações
          </Button>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default PolicyStep;
